import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from '@partials/contents-modal-slide';

import InfluencerProfile  from './profile';
import InfluencerContents from './contents';
// -------------------------------------------------------

class ProjectInfluencer extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showInfluencer = this.showInfluencer.bind(this);
    event.refreshInfluencer = this.refreshInfluencer.bind(this);
    event.setMessageMode = this.setMessageMode.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal  : false,
      detail : {},
      reload : false,
      side_tab : 'message',
      message_mode : false,
      last_insta_user_id : '',
    };
  }
  // -------------------------------------------------------
  
  /*
   * インフルエンサーの表示
   */
  showInfluencer(insta_user_id, reload, side_tab) {
    if( insta_user_id == undefined ){
      insta_user_id = this.state.last_insta_user_id;
      reload = false;
    }
    
    Utils.request.bind(this)('/api/project/influencer/detail', { project_id: this.props.data.project.id, insta_user_id: insta_user_id },
      function(res){
        
        if( reload !== false ){
          this.setState({ detail: res.body.data, modal: true, reload: true });
          setTimeout( function(){
            this.setState({ reload: false });
          }.bind(this), 10);
        } else {
          this.setState({ detail: res.body.data, modal: true });
        }
        
      }.bind(this)
    );
    
    this.setState({ last_insta_user_id: insta_user_id, message_mode: false });
    
    // タブを強制的に設定
    if( side_tab != undefined ) this.setState({ side_tab: side_tab });
  }
  // -------------------------------------------------------
  
  /*
   * リフレッシュ
   */
  refreshInfluencer(target_insta_user_id) {
    if( this.state.last_insta_user_id == target_insta_user_id ){
      this.showInfluencer.bind(this)(this.state.last_insta_user_id, false);
    }
  }
  // -------------------------------------------------------
  
  /*
   * モーダルクローズ
   */
  closeEvent() {
    this.setState({ modal: false });
  }
  // -------------------------------------------------------
  
  /*
   * DMモードの設定
   */
  setMessageMode(flg) {
    this.setState({ message_mode: flg });
  }
  // -------------------------------------------------------
  
  /*
   * DMモード終了
   */
  closeMessageMode() {
    this.setState({ message_mode: false });
  }
  // -------------------------------------------------------
  
  /*
   * タブの変更
   */
  changeTab(side_tab) {
    this.setState({ side_tab: side_tab });
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.state.detail;
    if( detail.influencer == undefined ) detail.influencer = {};
    
    let base = this.props.data;
    
    let message_mode = (this.state.message_mode == true) ? 'message-mode' : '';
    let sub_event = (this.state.message_mode == true) ? this.closeMessageMode.bind(this) : null;
    
    let progress_color = 'normal';
    try {
      Const.value.workflow.map((d) => { if( d.id == detail.workflow.progress ) progress_color = d.color; });
      if( detail.workflow.is_ng == 1 ) progress_color = 'ng';
    } catch(e) {}
    
    return (
      <div className={'project-side-influencer '+ message_mode}>
        <ContentsModal
          view       = {this.state.modal}
          width      = {330}
          height     = {320}
          //close_ev = {this.closeModal.bind(this)}
          cache      = {detail.influencer.insta_user_id}
          reload     = {this.state.reload}
          sub_event  = {sub_event}
          design     = {'color_'+ progress_color}
          auto_close = {!(this.state.message_mode)}
          html       = {
            <div className="modal-item">
              <InfluencerProfile data={this.props.data} detail={detail} refresh_ev={this.showInfluencer.bind(this)} />
              { (this.state.reload == false ) &&
                <InfluencerContents
                  base          = {base}
                  data          = {this.props.data}
                  detail        = {detail}
                  side_tab      = {this.state.side_tab}
                  message_mode  = {this.state.message_mode}
                  change_tab_ev = {this.changeTab.bind(this)}
                  refresh_ev    = {this.showInfluencer.bind(this)}
                  close_ev      = {this.closeEvent.bind(this)}
                />
              }
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectInfluencer;